import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { SingleValueProps } from 'react-select';
import type { CSSProperties } from 'react';

type SingleValueIconOption = {
  label: string;
  value?: string;
  icon?: IconProp;
};

type SingleValueIconProps = SingleValueProps<SingleValueIconOption, false>;

const SingleValueIcon = (props: SingleValueIconProps) => {
  const { innerProps, getStyles, ...rest } = props;
  return (
    <>
      <div
        {...innerProps}
        style={{
          ...(getStyles('singleValue', rest as never) as CSSProperties),
          color: 'var(--falcon-body-color)'
        }}
        className="d-flex align-items-center gap-1"
      >
        {props.data?.icon && (
          <FontAwesomeIcon
            icon={props.data.icon}
            title={
              typeof props.data.icon === 'string'
                ? props.data.icon
                : undefined
            }
          />
        )}
        {props.data.label}
      </div>
    </>
  );
};

export default SingleValueIcon;
